import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70daf2aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-breadcrumb" }
const _hoisted_2 = { class: "p-breadcrumb-home" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "p-breadcrumb-chevron pi pi-chevron-right" }, null, -1))
const _hoisted_4 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      _createElementVNode("li", _hoisted_2, [
        _createElementVNode("a", {
          class: "p-menuitem-link",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
          style: {"cursor":"pointer"}
        }, _toDisplayString(_ctx.home.label), 1)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model, (item, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          _hoisted_3,
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              class: "p-menuitem-link",
              href: item.to
            }, _toDisplayString(item.label), 9, _hoisted_4)
          ])
        ], 64))
      }), 128))
    ])
  ]))
}